import ExtendableError from '../lib/ExtendableError';

export class SmartcardRegistrationError extends ExtendableError { name = 'SmartcardRegistrationError'; }

export class SelfSmartcardRegistrationError extends ExtendableError { name = 'SelfSmartcardRegistrationError'; }

export class SmartcardPostcodeError extends SmartcardRegistrationError { name = 'SmartcardPostcodeError'; }

export class SmartcardAlreadyRegisteredError extends SmartcardRegistrationError { name = 'SmartcardAlreadyRegisteredError'; }

export class ACTError extends ExtendableError {
    static code = 3;
    name = 'ACTError';
}

export class SmartcardActivationError extends ExtendableError { name = 'SmartcardActivationError'; }
